import * as actions from '../constants/actions'
import { createActionCreator } from '../utils/redux'
import fetchLightStompunkter from '../dataSource/fetchLightStompunkter'

export function loadLightStompunkterIfNeeded() {
   return function(dispatch, getState) {
      const state = getState()
      const seenViews = state.seenViews
      const newView = {
         mapBounds: state.mapBounds,
         filter: state.filter
      }
      if (viewIsNotSeen(newView, seenViews)) {
         dispatch(loadLightStompunkter())
      }
   }
}

function viewIsNotSeen(newView, seenViews) {
    return seenViews == null
        || newFilterIsMoreInclusive(newView.filter, seenViews.filter)
        || newBoundsOutsideOfOldBounds(newView.mapBounds, seenViews.mapBounds)
}

function newFilterIsMoreInclusive(newFilter, oldFilter) {
    return Object.keys(newFilter).some(
        (key) => newFilter[key] && !oldFilter[key]
    )
}

function newBoundsOutsideOfOldBounds(newBounds, oldBounds) {
    return newBounds.north >= oldBounds.north
        || newBounds.east >= oldBounds.east
        || newBounds.south <= oldBounds.south
        || newBounds.west <= oldBounds.west;
}

export function loadLightStompunkter() {
   return async function(dispatch, getState) {
      let stompunkter
      const { mapBounds, filter } = getState()
      dispatch(loadLightStompunkterRequest())
      try {
          stompunkter = await fetchLightStompunkter(mapBounds, filter)
      }
      catch (error) {
          if (error.fetchError) {
              dispatch(loadLightStompunkterError(error.data))
              return
          }
          else {
              throw error
          }
      }
      dispatch(loadLightStompunkterSuccess(stompunkter, { mapBounds, filter }))
   }
}

export const loadLightStompunkterRequest = createActionCreator(actions.LOAD_LIGHT_STOMPUNKTER_REQUEST)

export const loadLightStompunkterError = createActionCreator(actions.LOAD_LIGHT_STOMPUNKTER_ERROR, 'error')

export const loadLightStompunkterSuccess = createActionCreator(actions.LOAD_LIGHT_STOMPUNKTER_SUCCESS, 'stompunkter', 'view')



// WEBPACK FOOTER //
// ./src/actionCreators/loadLightStompunkter.js